import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import CreateTagForm from "./CreateTagForm";
import { useLocation } from "react-router-dom";
const FormViewer = () => {
  const location = useLocation();
  const currentPathname = location.pathname;
  return (
    <>
      <Breadcrumbs
        mainTitle={
          currentPathname.includes("/edit") ? "Edit Tag" : "Create Tag"
        }
        parent="Tags"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateTagForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FormViewer;
